<template>
  <v-row>
    <v-col
      cols="8"
      sm="8"
      md="8"
    >
      <v-text-field
        v-model="optValue"
        :label="keyName"
        :disabled="justOption || optionsSet"
      />
    </v-col>
    <v-col
      cols="4"
      sm="4"
      md="4"
    >
      <v-checkbox
        v-model="justOption"
        label="N/V"
        :disabled="optionsSet"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CronjobOptionsInput',
  props: {
    optionValue: {
      type: Object,
      required: true,
    },

    keyName: {
      type: String,
      required: true,
    },

    optionsSet: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      optValue: null,
      justOption: false,
    };
  },

  watch: {
    optionValue() {
      this.optValue = this.optionValue.value;
      this.justOption = this.optionValue.justOption;
    },

    justOption(newValue) {
      if (newValue) {
        this.optValue = null;
      }

      this.updateParent();
    },

    optValue(newValue) {
      if (newValue) {
        this.updateParent();
      }
    },
  },

  methods: {
    updateParent() {
      this.$emit('updateOption', {
        keyName: this.keyName,
        optionValue: {
          value: this.optValue,
          justOption: this.justOption,
        },
      });
    },
  },
};
</script>
